import { Component } from '@angular/core';
import { MdDialog } from '@angular/material';
import { TdDialogService } from '@covalent/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Cita } from '../../../../models';
import { CitasService, LoginService } from '../../../../services/';

@Component({
  selector: 'qs-citasdetalle',
  templateUrl: './citasdetalle.component.html',
  viewProviders: [CitasService],
})

export class CitasDetalleComponent {

  public cita: Cita;
  public nombreProfesional: String;

  constructor(private _loginService: LoginService,
    private _citasService: CitasService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute) { }

  eliminar(): void {
    let message: string = 'Cita borrada correctamente.';
    let action: string = 'Ok';
    let duration: number = 3000;
    let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/citas/';
    this._dialogService.openConfirm({
      message: 'Pulse ACEPTAR para borrar la cita.',
      disableClose: true,
      title: 'Borrar cita',
      cancelButton: 'Cancelar',
      acceptButton: 'Aceptar',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this._citasService.eliminarCita(this.cita.id, this._loginService.consulta.numeroExpediente).subscribe((res: any) => {
          if (res.error !== undefined && res.error !== null) {
            this._loginService.mostrarMensaje(res.error.descripcion, action, duration);
            this._dialogService.closeAll();
            this._router.navigate([route]);
          } else {
            this._loginService.mostrarMensaje(message, action, duration);
            this._dialogService.closeAll();
            this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/citas']);
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje(message, action, duration);
        });
      }
    });
  }

  close(): void {
    this._dialogService.closeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/citas/citasdetalle/citasdetalle.component.ts